import { render, staticRenderFns } from "./psOrderDetails.vue?vue&type=template&id=0658bcae&"
import script from "./psOrderDetails.vue?vue&type=script&lang=js&"
export * from "./psOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./psOrderDetails.vue?vue&type=style&index=0&id=0658bcae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports